import { defineStore } from "pinia";
import { ref } from "vue";
import { DefaultService } from "@/openapi/lms";

// LMS capability flags resolved from the server (ADR 023). canAuthor gates the
// editor space; it is true for admins and for users holding an editor grant.
// Loaded once per session and read reactively by the nav + route guards.
export const useLmsCapabilitiesStore = defineStore("lms-capabilities", () => {
  const canAuthor = ref(false);
  const livePolls = ref(false);
  const loaded = ref(false);
  let inflight: Promise<void> | null = null;

  async function load() {
    try {
      const f = await DefaultService.getLmsFeatures();
      canAuthor.value = f.canAuthor ?? false;
      livePolls.value = f.livePolls ?? false;
    } catch {
      canAuthor.value = false;
      livePolls.value = false;
    } finally {
      loaded.value = true;
    }
  }

  // Idempotent: fetches once, dedupes concurrent callers, and is a no-op after
  // the first successful load.
  function ensureLoaded(): Promise<void> {
    if (loaded.value) return Promise.resolve();
    if (!inflight) {
      inflight = load().finally(() => {
        inflight = null;
      });
    }
    return inflight;
  }

  return { canAuthor, livePolls, loaded, load, ensureLoaded };
});
